import React, { Component, useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import "./CaseControl.scss";
import { connect } from "react-redux";
import NotificationCard from "./NotificationCard/NotificationCard";
import ApprovalPending from "./CaseApproval/ApprovalPending";
import Approval from "./CaseApproval/Approval";
import ChartCaseOverview from "./Chart/chart";
import { useQuery, useMutation } from "react-apollo";
import Emitter from "../../libs/Events";
import moment from "moment";
import gql from "graphql-tag";

const capitalize = (str) => {
  if (str.len < 1) return str;
  const words = str.split(" ");
  const finishedWords = [];
  for (let word of words) {
    finishedWords.push(
      word.slice(0, 1).toUpperCase() + word.substr(1, word.length - 1)
    );
  }

  return finishedWords.join(" ");
};

const QUERY = gql`
  query($user_code: String) {
    getActiveNotifications {
      id
      notification_type
      notification_text
      url
      shown_at
      user_code
      is_read
      expired_at
      event_notification_id
      timestamp_no
      created_at
      updated_at
      deleted_at
    }
    getLmsTimesheets(
      timesheet_id: ""
      secretary_user_code: ""
      start_date: ""
      end_date: ""
      contract_id: ""
      user_code: $user_code
      work_code: ""
      contract_name: ""
      is_billable: ""
      status_code: ""
      page: 1
    ) {
      count
      rows {
        timesheet_date
        timesheet_id
        description
        user_code
        original_time_unit
        status_code
        approved_by
        reviewed_by
        contract_id
        contract {
          contract_number
          client {
            client_code
          }
        }
        lawyer {
          user_code
          display_name
        }
      }
    }
  }
`;

const SeenMutation = gql`
  mutation setNotificationHasBeenRead($id: Int!) {
    ReadNotification(id: $id) {
      id
      is_read
    }
  }
`;

export const Notifications = () => {
  // Recheck notification once every 5 minutes
  // const [emitter, setEmitter] = useState(false);
  let responsible = JSON.parse(localStorage.getItem("_dentonslogin"));
  const { data, loading, error, refetch } = useQuery(QUERY, {
    pollInterval: 5 * 60 * 1000,
    variables: {
      user_code: responsible.user_code,
    },
  });

  const [readNotification] = useMutation(SeenMutation);
  const refetchQuery = () => refetch().then(() => {});

  useEffect(() => {
    Emitter.on("push_notification", refetchQuery);
    return () => {
      Emitter.off("push_notification", refetchQuery);
    };
  }, []);

  return (
    <React.Fragment>
      {(data ? data.getActiveNotifications : []).length > 0 ? (
        (data?.getActiveNotifications ?? [])
          .sort(
            (a, b) =>
              moment(a.created_at).diff(moment(b.created_at), "second") * -1
          )
          .map((x) => {
            return (
              <NotificationCard
                seen={x.is_read === 1}
                notification={x}
                onSeen={() => {
                  // Do nothing as this notification ia already read
                  if (x.is_read === 1) return;
                  readNotification({
                    variables: { id: x.id },
                  }).then(() => {});
                }}
                date={moment(x.shown_at).format("DD MMM YYYY HH:mm")}
                type={x.notification_type}
              >
                <div>{capitalize(x.notification_type)} Notification</div>
                <div>{x.notification_text}</div>
                {x.attachment_file && (
                  <div>
                    <span>Attachment:</span>
                    <div
                      className="file"
                      onClick={() => {
                        window.open(
                          "/notification_attachment/" + x.attachment_file
                        );
                      }}
                    >
                      <i className="fa fa-file-pdf-o" />
                      {x.attachment_file}
                    </div>
                  </div>
                )}
              </NotificationCard>
            );
          })
      ) : (
        <div className="text-center mt-5">
          <img
            src={require("../../images/nodataplus.png")}
            style={{ width: "40%" }}
            alt=""
          />
          <h5 className="text-center text-muted mt-5">
            Don't Have Notification
          </h5>
        </div>
      )}
    </React.Fragment>
  );
};

export const NotificationsTimesheet = () => {
  let responsible = JSON.parse(localStorage.getItem("_dentonslogin"));
  const { data, loading, error, refetch } = useQuery(QUERY, {
    pollInterval: 5 * 60 * 1000,
    variables: {
      user_code: responsible.user_code,
    },
  });

  return (
    <React.Fragment>
      {(data ? data.getLmsTimesheets.rows : []).length > 0 ? (
        (data?.getLmsTimesheets?.rows ?? []).map((item) => {
          return (
            <NotificationCard
              type="update"
              newstatus={
                item.description +
                " on Case Number " +
                item.contract.contract_number
              }
              date={moment(item.timesheet_date).format("D MMMM YYYY")}
            />
          );
        })
      ) : (
        <div className="text-center mt-5">
          <img
            src={require("../../images/nodataplus.png")}
            style={{ width: "40%" }}
            alt=""
          />
          <h5 className="text-center text-muted mt-5">
            No Data Timesheet Updates
          </h5>
        </div>
      )}
    </React.Fragment>
  );
};

class CaseControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      approved: "open",
      cOpen: 0,
      cApprove: 0,
      cProspect: 0,
      cCanceled: 0,
    };
  }

  render() {
    let userLogin = JSON.parse(localStorage.getItem("_dentonslogin"));
    let name =
      userLogin.first_name +
      " " +
      userLogin.middle_name +
      " " +
      userLogin.last_name;
    let date = new Date();
    let months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let day = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    let dateNow =
      day[date.getDay()] +
      ", " +
      date.getDate() +
      " " +
      months[date.getMonth()] +
      " " +
      date.getFullYear();

    return (
      <div className="animated fadeIn casecontrol">
        <Row
          className="mb-3 chart"
          style={{ backgroundColor: "#fff", margin: "1px" }}
        >
          <Col md="12" className="text-center p-3">
            <h4>
              Hello, <strong>{name}</strong>! Here is your case status on{" "}
              {dateNow}
            </h4>
          </Col>
          <Col md="2" className="">
            <div className="point">
              <div className="contain">
                <div className="row">
                  <div className="col-md-1">
                    <div className="point1"></div>
                  </div>
                  <div className="col-md-1">{this.state.cOpen}</div>
                  <div className="col-md-8">Open</div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <div className="point2"></div>
                  </div>
                  <div className="col-md-1">{this.state.cApprove}</div>
                  <div className="col-md-8">Approve</div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <div className="point3"></div>
                  </div>
                  <div className="col-md-1">{this.state.cProspect}</div>
                  <div className="col-md-8">Prospect</div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <div className="point4"></div>
                  </div>
                  <div className="col-md-1">{this.state.cCanceled}</div>
                  <div className="col-md-8">Canceled</div>
                </div>
              </div>
            </div>
          </Col>
          <Col md="10 pr-2">
            <ChartCaseOverview
              handleCStatus={(e) =>
                this.setState({
                  cOpen: e.open,
                  cApprove: e.approve,
                  cProspect: e.prospect,
                  cCanceled: e.canceled,
                })
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <div className="section">
              <div className="sectioncontent">
                <h4 className="float-left">
                  You might want to create new case?
                </h4>
                <a
                  href="#/caseprospect"
                  className="btn pull-right float-right ml-2"
                  style={{ backgroundColor: "purple", color: "white" }}
                >
                  <i className="fa fa-plus" /> New Prospect
                </a>
                <a
                  href="#/casenew"
                  className="btn btn-success pull-right float-right ml-2"
                >
                  <i className="fa fa-plus" /> New Case Opening
                </a>
                <br />
                <div style={{ clear: "both" }} />
              </div>
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col md="6" sm="12">
            <div className="section">
              <div className="sectioncontent">
                <h4 className="blocktext float-left">Case Status Open</h4>
                <button
                  className="btn btn-outline-dark pull-right float-right mr-2"
                  onClick={() =>
                    this.props.history.push({
                      pathname: "/caselist",
                      state: "OPEN",
                    })
                  }
                >
                  <i className="fa fa-external-link" /> View Case
                </button>
                <div className="clearfix" />
                <div className="caseslist">
                  <ApprovalPending />
                </div>
              </div>
            </div>
          </Col>
          <Col md="6" sm="12">
            <div className="section">
              <div className="sectioncontent">
                <h4 className="blocktext float-left">Case Status Cancelled</h4>
                <button
                  href="#/caselist"
                  className="btn btn-outline-dark pull-right float-right ml-2"
                  onClick={() =>
                    this.props.history.push({
                      pathname: "/caselist",
                      state: "APPROVE",
                    })
                  }
                >
                  <i className="fa fa-external-link" /> View Case
                </button>
                <div className="clearfix" />
                <div className="caseslist">
                  <Approval />
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col md="6" sm="12">
            <div className="section">
              <div className="sectioncontent">
                <h5>
                  <i className="fa fa-tasks" style={{ color: "#f44336" }} />{" "}
                  Notifications
                </h5>
                <div className="notifications">
                  <Notifications />
                </div>
              </div>
            </div>
          </Col>
          <Col md="6" sm="12">
            <div className="section">
              <div className="sectioncontent">
                <h5>
                  <i className="fa fa-tasks" style={{ color: "#f44336" }} />{" "}
                  Timesheet Updates
                </h5>
                <div className="notifications">
                  <NotificationsTimesheet />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect((props) => ({}))(CaseControl);
